import { NetworkStatus } from "@apollo/client";

type InitialQueryLoadingArgs = {
  loading: boolean;
  networkStatus?: NetworkStatus;
  itemCount: number;
  hasData: boolean;
  error?: unknown;
};

export function isInitialQueryLoading({
  loading,
  networkStatus,
  itemCount,
  hasData,
  error
}: InitialQueryLoadingArgs): boolean {
  if (itemCount > 0) {
    return false;
  }

  if (error && !loading) {
    return false;
  }

  return loading || !hasData || networkStatus === NetworkStatus.refetch;
}
